import { EinzaGraphiQLService } from "@/services/einzaGraphiQL"

import { calculateSummary, rearrangeYtdRevenueData } from "./revenueByAhg"

export const revenueYtdStatsByArticleMainGroup = async ({ admNumber, customerNumber } = {}) => {
  const currentYear = new Date().getFullYear()
  const currentMonth = new Date().getMonth() + 1
  const lastYear = currentYear - 1

  const currentYearMethod = customerNumber ? "customerStatsByArticleMainGroup" : "admStatsByArticleMainGroup"

  const currentYearQueries = [
    {
      method: `currentYearRevenue: ${currentYearMethod}`,
      variables: {
        ...(customerNumber ? { customerNumber } : { admNumber }),
        year: currentYear,
      },
      fields: ["articleMainGroup", "year", "revenue", "margin"],
    },
  ]

  const monthsUntilNow = Array.from({ length: currentMonth }, (_, i) => i + 1)

  const lastYearMethod = customerNumber ? "customerStatsByArticleMainGroupByMonth" : "admStatsByArticleMainGroupByMonth"

  const lastYearQueries = monthsUntilNow.map((month) => ({
    method: `lastYear_${month}: ${lastYearMethod}`,
    variables: {
      ...(customerNumber ? { customerNumber } : { admNumber }),
      year: lastYear,
      month,
    },
    fields: ["articleMainGroup", "year", "month", "revenue", "margin"],
  }))

  const currentYearMappedQuery = EinzaGraphiQLService.formQuery(currentYearQueries)
  const { currentYearRevenue } = (await EinzaGraphiQLService.getData(currentYearMappedQuery))?.data

  if (!currentYearRevenue) throw new Error("Data retrieval for current revenue stats failed")

  const lastYearMappedQuery = EinzaGraphiQLService.formQuery(lastYearQueries)
  const lastYearResponse = (await EinzaGraphiQLService.getData(lastYearMappedQuery))?.data

  if (!lastYearResponse) throw new Error("Data retrieval for last year revenue stats failed")

  const revenueStats = rearrangeYtdRevenueData({ currentYearRevenue, lastYearResponse })

  const summary = calculateSummary(revenueStats)

  return { summary, revenueStats }
}
